import { createSlice } from "@reduxjs/toolkit";
import { Client, CompaniesTable, IClientUI } from "./types/Clients.interface";
import {
  getCompanies,
  getCompaniesSearch,
  getDataCompanies,
  getDataUpdates,
  getFolderData,
  getFolders,
  updateDb,
} from "./clients.action";

const initialState: IClientUI = {
  ui: { loading: false, updateDbLoading: false },
};

export const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanies.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getCompanies.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.companies = action.payload as Client[];
      })
      .addCase(getCompanies.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(getDataCompanies.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getDataCompanies.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.companiesTable = action.payload as CompaniesTable[];
      })
      .addCase(getDataCompanies.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(getFolders.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getFolders.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.foldersSpecific = action.payload;
      })
      .addCase(getFolders.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(getFolderData.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getFolderData.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.folderData = action.payload;
      })
      .addCase(getFolderData.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(getCompaniesSearch.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getCompaniesSearch.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.companiesSearch = action.payload;
      })
      .addCase(getCompaniesSearch.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(getDataUpdates.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getDataUpdates.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.dataUpdates = action.payload;
      })
      .addCase(getDataUpdates.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(updateDb.pending, (state) => {
        state.ui.updateDbLoading = true;
      })
      .addCase(updateDb.fulfilled, (state) => {
        state.ui.updateDbLoading = false;
      })
      .addCase(updateDb.rejected, (state) => {
        state.ui.updateDbLoading = false;
      });
  },
});
